export default "__VITE_ASSET__DSP0n8nP__"